/*
 * Utility function to output "pretty" address string.
 * Any of the addresss properties could be blank, so this convoluted if statement mess takes care of not generating a string of commas.
 * In some places we want to add a line break so addresses look good on mobile, so that option is included.
 * The line break will only be added when street address details are present, otherwise there could be a line break for no reason.
 * Not showing any text for the adress if all fields are blank makes the design look poor, so a fallback value is included.
 */

const prettyAddress = (data, lineBreak = false) => {
    let prettyAddress = "";
    let addressData = false;
    if (
        data.property &&
        data.property.address &&
        typeof data.property.address !== "undefined"
    ) {
        addressData = data.property.address;
    }
    if (addressData) {
        if (addressData.lot_number) {
			prettyAddress = addressData.lot_number + " "
		}
		if (addressData.sub_number) {
			prettyAddress += addressData.sub_number
		}
        if (addressData.street_number) {
            prettyAddress = addressData.street_number;
        }

        if (addressData.street_name) {
            let prefix = "";
            if (addressData.street_number) {
                prefix = " ";
            }
            prettyAddress = prettyAddress + prefix + addressData.street_name;
        }

        if (addressData.street_type) {
            let prefix = "";
            if (addressData.street_number || addressData.street_name) {
                prefix = " ";
            }
            prettyAddress = prettyAddress + prefix + addressData.street_type + ", ";
        }

        if (lineBreak) {
            if (
                addressData.street_number ||
                addressData.street_name ||
                addressData.street_type
            ) {
                prettyAddress = prettyAddress + "<br>";
            }
        }

        if (addressData.suburb) {
            let prefix = "";
            if (
                addressData.street_number ||
                addressData.street_name ||
                addressData.street_type
            ) {
                prefix = " ";
            }
            prettyAddress = prettyAddress + prefix + addressData.suburb;
        }

        if (addressData.state) {
            let prefix = "";
            if (
                addressData.street_number ||
                addressData.street_name ||
                addressData.street_type ||
                addressData.suburb
            ) {
                prefix = " ";
            }
            prettyAddress = prettyAddress + prefix + addressData.state;
        }

        if (addressData.postcode) {
            let prefix = "";
            if (
                addressData.street_number ||
                addressData.street_name ||
                addressData.street_type ||
                addressData.suburb ||
                addressData.state
            ) {
                prefix = " ";
            }
            prettyAddress = prettyAddress + prefix + addressData.postcode;
        }
    }

    if (prettyAddress === "") {
        prettyAddress = "[No Address Details Available]";
    }

    return prettyAddress;
};

export default prettyAddress;
